let guard = null
let approved = false
let onPending = null
export function registerTemplateGuard(callback, pending = null) {
	guard = callback
	onPending = pending
	approved = false
	return () => {
		if (guard === callback) {
			guard = null
			onPending = null
			approved = false
		}
	}
}
export async function confirmTemplateNavigation() {
	if (approved) return false
	const currentGuard = guard
	const allowed = currentGuard ? await currentGuard() : true
	if (!allowed || approved || currentGuard !== guard) return false
	approved = true
	if (onPending) onPending(true)
	return true
}
export function isTemplateNavigationApproved() {
	return approved
}
export function resetTemplateNavigation() {
	approved = false
	if (onPending) onPending(false)
}
